import getSymbolFromCurrency from 'currency-symbol-map';

export function capitalizeFirstLetter(str: string, locale = navigator.language) {
  const [first, ...rest] = str;
  return [first.toLocaleUpperCase(locale), ...rest].join('');
}

interface MonetizeOptions {
  beginning?: boolean;
  currency?: string;
}

// Use this function to transform numbers or strings to a money format way.
// E.g. `192` into `€192`
// This will be useful if we ever need to display currencies in a localized way
export function monetizeString(str: string | number, { beginning = true, currency = 'eur' }: MonetizeOptions = {}) {
  const symbol = getSymbolFromCurrency(currency);
  return beginning ? `${symbol}${str.toString()}` : `${str.toString()} ${currency?.toUpperCase()}`;
}

export function isValidURL(str : string) : boolean {
  // eslint-disable-next-line no-useless-escape
  const expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
  const regex = new RegExp(expression);
  return regex.test(str);
}

export enum Protocols {
  HTTP = 'http',
  HTTPS = 'https',
  FTP = 'ftp',
  SMTP = 'smtp',
}

export function hasProtocol(url : string, protocols: Protocols[] = [Protocols.HTTPS, Protocols.HTTP]) : boolean {
  return protocols.some(protocol => url.startsWith(protocol));
}

export function toUpperCaseExceptSpecialChars(str: string): string {
  const specialChars = ['ß'];
  let upperCaseStr = '';
  for (let i = 0; i < str.length; i++) {
    const el = str[i];
    if (specialChars.includes(el)) {
      upperCaseStr += el;
    } else {
      upperCaseStr += el.toUpperCase();
    }
  }
  return upperCaseStr;
}
